export default __webpack_public_path__ + "static/media/15.1b4510cd.svg";